//telas externas
import inicio from '../pages/inicio.vue'
import USC_12_282 from '../pages/reativaBH/USC_12_282.vue';

//Telas de erro
import pagina403 from '../pages/erros/403.vue'
import pagina404 from '../pages/erros/404.vue'

const routes = [
    {
        name: 'inicio',
        meta: { requiresAuth: false },
        path: '/',
        component: inicio,
    },
    {
        name: 'USC.12.282',
        meta: { requiresAuth: false },
        path: '/reativaBH',
        component: USC_12_282,
    },
    {
        name: '403',
        path: '/403',
        component: pagina403,
    },
    //tela "não encontrada"
    {
        path: '*',
        name: '/404',
        component: pagina404,
    },

    { path: '*', redirect: '/404', meta: { requiresAuth: false } },
];

export default routes;